import React, { useEffect } from "react";
import "./why-choose.css";
import Common_title from "../../common/common-title/Common_title";
import Bg_animation from "./Bg_animation";

const Why_choose = () => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
          } else {
            entry.target.classList.remove("in-view");
          }
        });
      },
      { threshold: 0.4 }
    );

    const elements = document.querySelectorAll(
      ".Why_choose_section .contentdiv"
    );
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <section className="Why_choose_section margin_section">
        <div className="container">
          <div className="row">
            <div className="col-lg-9 mx-auto">
              <Common_title
                title={"URBAN BUILD"}
                subtitle={
                  "Why Use UrbanBuild App?"
                }
              />

              <div className="contentdiv">
                <div className="row">
                  <div className="col-md-4">
                    <div className="left_sec">
                      <div className="choose_box">
                        <h1 className="number">01</h1>
                        <p className="whytitle">Browse Nearby Vendors & Experts</p>
                        <p className="content">
                          Quickly find trusted professionals in <br></br>your city with just a few taps.
                        </p>
                      </div>

                      <div className="choose_box">
                        <h1 className="number">02</h1>
                        <p className="whytitle">Post Your Site Requirements Easily</p>
                        <p className="content">
                          Upload details, photos, and needs <br></br> directly through the app.
                        </p>
                      </div>

                      <div className="choose_box">
                        <h1 className="number">03</h1>
                        <p className="whytitle">Send Inquiries Directly</p>
                        <p className="content">
                          Connect with vendors or experts <br></br>
                          instantly — no middleman
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="mid_sec">
                      <img
                        className="mockupimg"
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/images/home/why-choose/mockup.png"
                        }
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="right_sec">
                      <div className="choose_box">
                        <h1 className="number">04</h1>
                        <p className="whytitle">Manage Your Service Requests</p>
                        <p className="content">
                          Track inquiries, responses, and service <br></br>
                          history in one place.
                        </p>
                      </div>

                      <div className="choose_box">
                        <h1 className="number">05</h1>
                        <p className="whytitle">Get Real-Time Updates</p>
                        <p className="content">
                          Receive notifications via WhatsApp <br></br>
                          and app alerts instantly.
                        </p>
                      </div>

                      <div className="choose_box">
                        <h1 className="number">06</h1>
                        <p className="whytitle">Ratings, Reviews & Secure Info</p>
                        <p className="content">
                          Make informed decisions with verified <br></br>
                          reviews and profiles.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="animation_div">
                    <Bg_animation />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Why_choose;
